import React from 'react';
import { projectTypes } from '../../utils/estimator';
import { tabBase, tabActive, tabIdle, sectionTitle } from './estimateUi';

export default function StepProjectType({ isUA, projectType, onChange }) {
  return (
    <div className="relative z-[1] pb-10 border-b border-border/60">
      <p className={`block ${sectionTitle}`}>{isUA ? 'Тип проекту' : 'Project type'}</p>
      <div className="relative z-[1] flex flex-wrap gap-3 items-start">
        {projectTypes.map((pt) => (
          <button
            key={pt.id}
            type="button"
            onClick={() => onChange(pt.id)}
            className={`${tabBase} ${projectType === pt.id ? tabActive : tabIdle}`}
            data-testid={`cfg-type-${pt.id}`}
          >
            {isUA ? pt.labelUA : pt.labelEN}
          </button>
        ))}
      </div>
    </div>
  );
}
